import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminApp from './admin/AdminApp';
import mixpanel from 'mixpanel-browser';

const root = ReactDOM.createRoot(document.getElementById('root'));

// The admin/user back office lives at /admin and /invite/<token>. It is a
// separate concern from the public checkout app, with its own auth and no
// customer analytics — mount it directly and skip the Mixpanel/Umami init.
const path = window.location.pathname;
const isAdmin = path.startsWith('/admin') || path.startsWith('/invite');

if (isAdmin) {
  root.render(<AdminApp />);
} else {
  const urlSearchParams = new URLSearchParams(window.location.search);

  mixpanel.init('44dc211c74066867cc2ad3d2888384df', {debug: true});

  mixpanel.track('Page View', {
      'url' : urlSearchParams.get('artistUrl')
  });

  // Umami analytics, production-only. Auto-tracks pageviews; custom events
  // fire from analytics.js -> umami.track() throughout the React tree.
  if (process.env.NODE_ENV === 'production' && !document.getElementById('umami-script')) {
      const s = document.createElement('script');
      s.id = 'umami-script';
      s.defer = true;
      s.src = 'https://analytics.olliemail.net/script.js';
      s.setAttribute('data-website-id', '0ffd408b-d119-4243-aa03-0eb8f9a557de');
      document.head.appendChild(s);
  }

  root.render(<App />);
}
